/* 🤖 this file was generated by script */
export const wiconPaperclip = {
  name: 'paperclip',
  data: `<svg viewBox="0 0 24 24"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21.15 10.9l-9.01 9.02a5.25 5.25 0 01-7.43-7.43l9.02-9.02a3.5 3.5 0 014.95 4.95l-8.66 8.67a1.75 1.75 0 11-2.48-2.48l7.6-7.6"/></svg>`,
};
